import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

export const WhyKorean = () => {
  const { t } = useLanguage();
  return (
    <section
      data-testid="why-korean-section"
      className="py-20 md:py-28 bg-[#0e0e11] text-neutral-100"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid md:grid-cols-12 gap-12 md:gap-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4 mb-8">
              <span className="divider-line"></span>
              <span className="eyebrow text-lilac">{t.whyKorean.eyebrow}</span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-neutral-100 tracking-tight">
              {t.whyKorean.titleA}
              <span className="block italic text-lilac font-light">{t.whyKorean.titleB}</span>
            </h2>
          </div>
          <div className="md:col-span-7 space-y-8">
            <p className="text-lg md:text-xl text-neutral-300 leading-relaxed font-light">
              {t.whyKorean.p1}
            </p>
            <div className="border-t border-white/10 pt-8">
              <p className="text-base md:text-lg text-neutral-400 leading-relaxed font-light max-w-2xl">
                {t.whyKorean.p2}
              </p>
            </div>
            <div className="border-t border-white/10 pt-8">
              <p className="text-base md:text-lg text-neutral-400 leading-relaxed font-light max-w-2xl">
                {t.whyKorean.p3}
              </p>
            </div>
            <div className="border-t border-white/10 pt-8">
              <p className="text-base md:text-lg text-neutral-300 leading-relaxed font-light max-w-2xl">
                {t.whyKorean.p4}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
